/* Ivalro — microanimaciones de navegación y confianza (vanilla JS + Web Animations API).
   · Galería de la ficha: fundido suave al cambiar de foto y zoom que sigue al ratón (solo ordenador).
   · Menú móvil: los enlaces entran en cascada al abrirlo.
   · Buscador: los resultados aparecen en cascada mientras escribes.
   · Tarjetas de producto: la foto del bote se inclina un poco al pasar el ratón (CSS).
   · Sellos de confianza de la ficha: sus iconos se dibujan trazo a trazo al aparecer.
   · Valoraciones: las estrellas se rellenan una a una al aparecer.
   Con "reducir movimiento" activado no se anima nada. */
(function () {
  if (window.__ivnMotionInit) return;
  window.__ivnMotionInit = true;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (reduce || !Element.prototype.animate) return;
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var EASE = 'cubic-bezier(.22,1,.36,1)';

  var css =
    // galería: zoom con el ratón
    '.pf-galeria-main.ivn-zoomable{overflow:hidden;cursor:zoom-in}' +
    '.pf-galeria-main.ivn-zoomable img{transition:transform .35s cubic-bezier(.22,1,.36,1)}' +
    '.pf-galeria-main.ivn-zoom img{transform:scale(1.85);transition:transform .18s ease-out}' +
    // tarjetas: el bote se inclina un poco
    '@media (hover:hover) and (pointer:fine){' +
      '.hm-producto-card:hover .hm-producto-imagen img{transform:rotate(-5deg) translateY(-4px) scale(1.05)!important}' +
      '.card-wrapper .card__media img{transition:transform .5s cubic-bezier(.22,1,.36,1)!important}' +
      '.card-wrapper:hover .card__media img:first-child{transform:rotate(-4deg) scale(1.04)!important}' +
      '.pf-rel-card img{transition:transform .5s cubic-bezier(.22,1,.36,1)}' +
      '.pf-rel-card:hover img{transform:rotate(-5deg) scale(1.05)}' +
      '.hmq-tarjeta-media img,.hmp-item img{transition:transform .5s cubic-bezier(.22,1,.36,1)}' +
      '.hmq-tarjeta:hover .hmq-tarjeta-media img,.hmp-item:hover img{transform:rotate(-4deg) scale(1.04)}' +
    '}';
  // Solo zoom y efectos al pasar el ratón: se añaden cuando la página ya ha cargado (recalculan toda la página)
  function ponerEstilos() {
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
  }
  function diferirEstilos() {
    if (window.requestIdleCallback) requestIdleCallback(ponerEstilos, { timeout: 2000 }); else setTimeout(ponerEstilos, 300);
  }
  if (document.readyState === 'complete') diferirEstilos();
  else window.addEventListener('load', diferirEstilos, { once: true });

  function onVisible(el, fn, threshold) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { io.disconnect(); fn(); }
    }, { threshold: threshold || 0.5 });
    io.observe(el);
  }

  /* ---------- 1) galería de la ficha ---------- */
  function initGaleria() {
    document.querySelectorAll('[data-pf-galeria-main]').forEach(function (img) {
      if (img.__ivn) return;
      img.__ivn = true;
      // fundido al cambiar de foto (pf-scripts.js cambia el src al pulsar una miniatura)
      new MutationObserver(function () {
        // respuesta inmediata: la foto actual se atenúa mientras carga la nueva
        var espera = (img.complete && img.naturalWidth) ? null :
          img.animate([{ opacity: 1 }, { opacity: 0.35, filter: 'blur(3px)' }], { duration: 160, easing: 'ease-out', fill: 'forwards' });
        function anim() {
          if (espera) espera.cancel();
          img.animate([
            { opacity: 0, transform: 'scale(1.03)', filter: 'blur(6px)' },
            { opacity: 1, transform: 'scale(1)', filter: 'blur(0)' }
          ], { duration: 420, easing: EASE });
        }
        if (img.complete && img.naturalWidth) anim(); else img.addEventListener('load', anim, { once: true });
      }).observe(img, { attributes: true, attributeFilter: ['src'] });

      // zoom que sigue al ratón (solo en ordenador)
      var box = img.closest('.pf-galeria-main');
      if (!box || !canHover) return;
      box.classList.add('ivn-zoomable');
      box.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = box.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x.toFixed(1) + '% ' + y.toFixed(1) + '%';
        box.classList.add('ivn-zoom');
      });
      box.addEventListener('pointerleave', function () { box.classList.remove('ivn-zoom'); });
    });
  }

  /* ---------- 2) menú móvil en cascada ---------- */
  function initMenu() {
    document.querySelectorAll('details.ivh-menu').forEach(function (det) {
      if (det.__ivn) return;
      det.__ivn = true;
      det.addEventListener('toggle', function () {
        if (!det.open) return;
        var panel = det.querySelector('.ivh-menu-panel');
        if (!panel) return;
        panel.animate([{ opacity: 0, transform: 'translateY(-6px) scale(.98)' }, { opacity: 1, transform: 'none' }],
          { duration: 260, easing: EASE });
        var links = panel.querySelectorAll('a');
        for (var i = 0; i < links.length; i++) {
          links[i].animate([{ opacity: 0, transform: 'translateX(-10px)' }, { opacity: 1, transform: 'none' }],
            { duration: 320, delay: Math.min(i * 22, 420), easing: EASE, fill: 'backwards' });
        }
      });
    });
  }

  /* ---------- 3) resultados del buscador en cascada ---------- */
  function initBuscador() {
    document.querySelectorAll('[data-ivh-buscar-resultados]').forEach(function (caja) {
      if (caja.__ivn) return;
      caja.__ivn = true;
      new MutationObserver(function () {
        var items = caja.querySelectorAll(':scope > *');
        for (var i = 0; i < items.length; i++) {
          if (items[i].__ivn) continue;
          items[i].__ivn = true;
          items[i].animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
            { duration: 280, delay: Math.min(i * 40, 320), easing: EASE, fill: 'backwards' });
        }
      }).observe(caja, { childList: true });
    });
  }

  /* ---------- 5) sellos de confianza que se dibujan ---------- */
  var SELLOS = '.pf-confianza-badge svg, .pf-garantia svg';
  function initSellos() {
    document.querySelectorAll(SELLOS).forEach(function (svg) {
      if (svg.__ivn || svg.getAttribute('fill') !== 'none') return; // solo iconos de trazo
      svg.__ivn = true;
      var formas = svg.querySelectorAll('path, circle, rect, polyline, line, ellipse');
      if (!formas.length) return;
      formas.forEach(function (f) {
        f.setAttribute('pathLength', '1');
        f.style.strokeDasharray = '1';
        f.style.strokeDashoffset = '1';
      });
      var grupo = svg.closest('.pf-confianza-grid, .pf-compra-inner') || svg;
      var orden = Array.prototype.indexOf.call(grupo.querySelectorAll(SELLOS), svg);
      onVisible(svg, function () {
        formas.forEach(function (f, k) {
          var a = f.animate([{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }],
            { duration: 700, delay: Math.max(0, orden) * 120 + k * 160, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' });
          function fin() { f.style.strokeDashoffset = '0'; }
          a.finished.then(fin, fin);
          setTimeout(fin, 2600 + Math.max(0, orden) * 120);
        });
      }, 0.6);
    });
  }

  /* ---------- 6) estrellas que se rellenan una a una ---------- */
  function initEstrellas() {
    document.querySelectorAll('.pf-stars, .rating-star, [data-ivn-estrellas]').forEach(function (fila) {
      if (fila.__ivn) return;
      fila.__ivn = true;
      var estrellas = fila.querySelectorAll('svg');
      if (!estrellas.length) return;
      estrellas.forEach(function (s) { s.style.opacity = '0'; });
      onVisible(fila, function () {
        estrellas.forEach(function (s, i) {
          var a = s.animate([
            { opacity: 0, transform: 'scale(.2) rotate(-40deg)' },
            { opacity: 1, transform: 'scale(1.25) rotate(8deg)', offset: 0.6 },
            { opacity: 1, transform: 'none' }
          ], { duration: 460, delay: i * 120, easing: 'cubic-bezier(.34,1.56,.64,1)', fill: 'backwards' });
          s.style.opacity = '';
          void a;
        });
      }, 0.8);
    });
  }

  function boot() { initGaleria(); initMenu(); initBuscador(); initSellos(); initEstrellas(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
